export default __webpack_public_path__ + "static/bulle_vert_deg-a8db077fcbfc748fa6383451f674022a.png";